import React, { Component } from 'react'; // eslint-disable-line
import ProjectItem from './ProjectItem';
import NewProjectItem from './NewProjectItem';

class ProjectsList extends Component {
    constructor(props) {
        super(props);
        this.deleteProject = this.deleteProject.bind(this);
    }

    getChurchInitials = (church) => { // eslint-disable-next-line
    if(typeof church != 'undefined' && church !== null) {
            return church.split(' ')
                .map((x) => { return x[0]; })
                .join('')
                .substring(0, 4);
        }

        return '';
    }

    deleteProject(project) {
        this.props.deleteProject(project);
    }

    render() {
        const {
            projects,
            newProjectOnClick,
        } = this.props;
        return (
            <div data-qa="project-list" className="project-list">
                <NewProjectItem createNew={newProjectOnClick} />
                {projects.map((project) => {
                    return (
                        <ProjectItem
                            key={project.id}
                            project={project}
                            deleteProject={this.deleteProject}
                            church={this.getChurchInitials(project.latestVersion.churchName)}
                        />
                    );
                })}
            </div>

        );
    }
}

export default ProjectsList;
